import { render, staticRenderFns } from "./AddBillingParameter.vue?vue&type=template&id=5ba255ce"
import script from "./AddBillingParameter.vue?vue&type=script&lang=js"
export * from "./AddBillingParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports